import storeNonReactive from '@/modules/fahrdienst452/storeNonReactive';
import dateUtils from '@/common/dateUtils';

export default {
  addUmlaufToKursUmlauefe({ umlauf, kursUmlauefe, tourHash, kurs, umlaufInfo, fromTo }) {
    if (umlauf && kursUmlauefe.kursAndUmlauf) {
      let kursAndUmlauf = kursUmlauefe.kursAndUmlauf;
      if (!kursAndUmlauf) {
        kursUmlauefe.kursAndUmlauf = {};
      }

      let kurseOnUmlauf = kursUmlauefe.kursAndUmlauf[umlauf] || {
        kurs: umlaufInfo.kurs,
        kurse: umlaufInfo.kurse,
        fromTo: `<span style="font-size:12px"> ${fromTo}</span>`,
        tourHash,
      };
      // kurseOnUmlauf.kurse.push(kurs);
      kursUmlauefe.kursAndUmlauf[umlauf] = kurseOnUmlauf;
    }
  },

  /**
   * Returns umlauefe of the given line. Returns an object with the linienKuerzel and a kursAndUmlauf object containing Umlauf objects mapped by linienKuerzel
   * @param kursUmlauefeByLineKuerzel - Kurs umlauf map by lineKuerzel
   * @param linienKuerzel - the linienKuerzel
   * @returns {{linienKuerzel:String, kursAndUmlauf: {}}}
   */
  getUmlauefeOfLinienKuerzel(kursUmlauefeByLineKuerzel, linienKuerzel) {
    let kursUmlauefe = kursUmlauefeByLineKuerzel[linienKuerzel];

    if (!kursUmlauefe) {
      kursUmlauefe = { kursAndUmlauf: {}, linienKuerzel: null };
      kursUmlauefeByLineKuerzel[linienKuerzel] = kursUmlauefe;
    }
    kursUmlauefe.linienKuerzel = linienKuerzel;
    return kursUmlauefe;
  },
  createKursUmlauefeByLineKuerzel(fahrdienst452TimetableItems) {
    const kursUmlauefeByLineKuerzel = {};

    fahrdienst452TimetableItems.forEach((timetableItem) => {
      const tourHash = timetableItem.tourHash;
      const umlaufInfo = storeNonReactive.umlaufInfoByTourHash[tourHash];

      if (umlaufInfo && umlaufInfo.header) {
        const dateString = timetableItem.day ? dateUtils.reformatDateIsoStringAsYYYYMMDD(timetableItem.day) : '';
        const umlaufFrom = umlaufInfo.umlaufFrom && dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, umlaufInfo.umlaufFrom, dateString);
        const umlaufTo = umlaufInfo.umlaufTo && dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, umlaufInfo.umlaufTo, dateString);
        let fromTo = ` (${umlaufFrom ? umlaufFrom : ''}${umlaufFrom ? '-' : ''}${umlaufTo ? umlaufTo : ''})`;

        const kurs = timetableItem.kurs;
        const linien = umlaufInfo.linien;

        const header = umlaufInfo.header;
        const { umlauf, linienKuerzel } = header;

        let kursUmlauefe = this.getUmlauefeOfLinienKuerzel(kursUmlauefeByLineKuerzel, linienKuerzel);

        this.addUmlaufToKursUmlauefe({ umlauf, kursUmlauefe, tourHash, kurs, umlaufInfo, fromTo });

        // Add to translated lines as well
        linien.forEach((linie) => {
          let alternativeLinienKuerzel = storeNonReactive.fahrdienst452LinesByLine[linie];
          if (alternativeLinienKuerzel) {
            let linienKursUmlauefe = this.getUmlauefeOfLinienKuerzel(kursUmlauefeByLineKuerzel, alternativeLinienKuerzel.kuerzel);
            this.addUmlaufToKursUmlauefe({ umlauf, kursUmlauefe: linienKursUmlauefe, tourHash, kurs, umlaufInfo, fromTo });
          }
        });

        kursUmlauefeByLineKuerzel[linienKuerzel] = kursUmlauefe;
      }
    });
    return kursUmlauefeByLineKuerzel;
  },
};
